<template>
  <div>
    <v-nav :nav-idx="4"></v-nav>
    <div class="main">
      <div class="online">
        当前位置：
        <a herf="javaScript:;" @click="productCenter()">产品中心</a>
        <router-link
          :to="{ path: `/product/${categoryFristId}` }"
          v-if="categoryLeve == 1 || categoryLeve == 2 || categoryLeve == 3"
        >
          > {{ categoryFristName }}</router-link
        >
        <router-link
          :to="{ path: `/product/${categoryId}` }"
          v-if="categoryLeve == 2 || categoryLeve == 3"
        >
          > {{ categoryName }}</router-link
        >
        <router-link
          :to="{ path: `/product/${categoryThirdId}` }"
          v-if="categoryLeve == 3"
        >
          >{{ categoryThirdName }}</router-link
        >
      </div>
      <div class="product" v-if="total > 0">
        <div class="select">
          <a
            href="#"
            class="item synthesize"
            :class="!from.sid ? 'active' : ''"
            @click="synthesize(1)"
            >综合</a
          >
          <a
            href="#"
            class="item price"
            :class="from.priceOrder ? 'active' : ''"
            @click="synthesize(2)"
            ><span>价格</span
            ><em
              ><i
                class="arrow_top"
                :class="from.priceOrder == 'asc' ? 'active' : ''"
              ></i
              ><i
                class="arrow_bottom"
                :class="from.priceOrder == 'desc' ? 'active' : ''"
              ></i></em
          ></a>
          <a
            href="#"
            class="item new"
            :class="from.news == 1 ? 'active' : ''"
            @click="synthesize(3)"
            >最新</a
          >
        </div>
        <div class="list">
          <ul>
            <li v-for="item in goodsList" :key="item.id">
              <router-link :to="`/product_details/${item.id}`">
                <div class="photo"><img :src="item.image" /></div>
                <div class="name">{{ item.storeName }}</div>
                <div class="price">
                  <span>￥{{ item.price }}</span>
                  <span>月销{{ item.sales }}</span>
                </div>
              </router-link>
            </li>
            <!-- <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li>
            <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li>
            <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li>
            <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li>
            <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li>
            <li>
              <a href="">
                <div class="photo"><img src="../../assets/imgs/c1.png" /></div>
                <div class="name">鼠标滑过商品名称商品商品名称商品名称商品</div>
                <div class="price">
                  <span>￥999.00</span>
                  <span>月销98</span>
                </div>
              </a>
            </li> -->
          </ul>
          <el-pagination
            background
            layout="prev, pager, next"
            v-if="total >= 10"
            @current-change="cPage"
            :current-page="from.page"
            :page-size="from.limit"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <div class="default-main" v-if="total == 0"><p>暂无数据</p></div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import vNav from "../../components/nav";
import vFooter from "../../components/footer";
import { requestProducts, requestIndexCategory } from "../../util/request";
import { successAlert, warningAlert } from "../../util/alert";
import { isPhone } from "../../util/tools";
import Cookies from "js-cookie";
export default {
  components: {
    vNav,
    vFooter,
  },
  created() {
    this.getGoodsList();
    this.from.sid = this.$route.params.id;
  },
  data() {
    return {
      user: Cookies.get("userInfo") ? JSON.parse(Cookies.get("userInfo")) : {},
      goodsList: [],
      //id: this.$route.params.id,
      from: {
        keyword: this.$route.query.keyword,
        limit: 10,
        page: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        news: "",
        priceOrder: "",
        sid: this.$route.params.id,
      },
      total: 1,
      tabIndex: 0,
      category: [],
      categoryLeve: "",
      categoryFristName: "",
      categoryFristId: "",
      categoryName: "",
      categoryId: "",
      categoryThirdName: "",
      categoryThirdId: "",
      menuList: [],
    };
  },
  computed: {},
  watch: {
    $route(to, from) {
      console.log("watch", this.$route.params.id);
      this.from.sid = this.$route.params.id;
      //console.log(this.from.sid)
      this.from.page = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.from.keyword = this.$route.query.keyword;
      this.getGoodsList();
    },
  },
  methods: {
    productCenter() {
      this.$router.push({
        path: "/product/" + 0,
        query: {},
      });
      //this.handleChangeMenuList();
    },
    synthesize(val) {
      this.tabIndex = val;
      if (val == 1) {
        this.from.sid = 0;
      } else if (val == 2) {
        this.from.priceOrder =
          this.from.priceOrder == ""
            ? "asc"
            : this.from.priceOrder == "asc"
            ? "desc"
            : "asc";
      } else if (val == 3) {
        this.from.news = this.from.news == 0 ? 1 : 0;
      }
      this.getGoodsList();
    },
    getGoodsList() {
      console.log("getGoodsList", this.from.keyword);
      requestProducts({
        keyword: this.from.keyword,
        limit: this.from.limit,
        page: this.from.page,
        news: this.from.news,
        priceOrder: this.from.priceOrder,
        sid: this.from.sid,
      }).then((res) => {
        if (res.data.status == 200) {
          this.goodsList = res.data.data;
          this.total = res.data.total;
          this.getCategoryList();
        } else {
          warningAlert(res.data.msg);
        }
      });
    },
    productdetail(id) {
      this.$router.push({
        path: `/product_details/${id}`,
      });
    },
    //修改页码
    cPage(page) {
      //this.form.pageNum=a
      //    if(document.body.scrollTop){
      //          document.body.scrollTop = 0
      //        }else {
      //          document.documentElement.scrollTop = 0
      //        }
      //this.getNewsList();
      var sid = this.from.sid;
      this.$router.push({
        path: "/product/" + sid,
        query: {
          page,
          keyword: this.$route.query.keyword,
        },
      });
    },
    getCategoryList() {
      requestIndexCategory().then((res) => {
        if (res.data.status == 200) {
          this.menuList = res.data.data;
          console.log(this.from.sid);
          //this.$emit('handleChangeMenuList', this.menuList)
          for (var i = 0; i < this.menuList.length; i++) {
            if (this.from.sid == this.menuList[i].id) {
              this.categoryFristName = this.menuList[i].cateName;
              this.categoryFristId = this.menuList[i].id;
              this.categoryLeve = 1;
            } else {
              for (var j = 0; j < this.menuList[i].children.length; j++) {
                if (this.from.sid == this.menuList[i].children[j].id) {
                  this.categoryFristName = this.menuList[i].cateName;
                  this.categoryFristId = this.menuList[i].id;
                  this.categoryName = this.menuList[i].children[j].cateName;
                  this.categoryId = this.menuList[i].children[j].id;
                  this.categoryLeve = 2;
                } else {
                  for (
                    var k = 0;
                    k < this.menuList[i].children[j].children.length;
                    k++
                  ) {
                    if (
                      this.from.sid ==
                      this.menuList[i].children[j].children[k].id
                    ) {
                      this.categoryFristName = this.menuList[i].cateName;
                      this.categoryFristId = this.menuList[i].id;
                      this.categoryName = this.menuList[i].children[j].cateName;
                      this.categoryId = this.menuList[i].children[j].id;
                      this.categoryThirdName = this.menuList[i].children[
                        j
                      ].children[k].cateName;
                      this.categoryThirdId = this.menuList[i].children[
                        j
                      ].children[k].id;
                      this.categoryLeve = 3;
                      return;
                    }
                    this.categoryFristName = "";
                    this.categoryFristId = "";
                    this.categoryName = "";
                    this.categoryId = "";
                    this.categoryThirdName = "";
                    this.categoryThirdId = "";
                    this.categoryLeve = "";
                  }
                }
              }
            }
          }
        } else {
          warningAlert(res.data.msg);
        }
      });
    },
    // handleChangeMenuList(val) {
    //   console.log(val)
    //   for (var i = 0; i < val.length; i++) {
    //     if(this.from.sid==val[i].id){
    //       this.categoryFristName=val[i].cateName
    //       this.categoryFristId=val[i].id
    //       this.categoryLeve=1
    //     }else{
    //       for (var j = 0; j < val[i].children.length; j++){
    //         if(this.from.sid==val[i].children[j].id){
    //           this.categoryFristName=val[i].cateName
    //       this.categoryFristId=val[i].id
    //           this.categoryName=val[i].children[j].cateName
    //           this.categoryId=val[i].children[j].id
    //           this.categoryLeve=2;
    //         }else{
    //           for (var k = 0; k < val[i].children[j].children.length; k++){
    //             if(this.from.sid==val[i].children[j].children[k].id){
    //               this.categoryFristName=val[i].cateName
    //               this.categoryFristId=val[i].id
    //               this.categoryName=val[i].children[j].cateName
    //               this.categoryId=val[i].children[j].id
    //               this.categoryThirdName=val[i].children[j].children[k].cateName
    //               this.categoryThirdId=val[i].children[j].children[k].id
    //               this.categoryLeve=3;
    //             }else{

    //             }
    //           }
    //         }
    //       }
    //     }

    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.main {
  padding-top: 30px;
  margin-bottom: 80px;
  min-height: 53vh;
  .default-main {
    min-height: 100%;
    text-align: center;
    p {
      padding-top: 20vh;
      font-size: 36px;
      font-weight: 600;
      line-height: 1.5;
      color: #ccc;
    }
  }
  .online {
    width: 1200px;
    margin: 0 auto;
    border-bottom: 1px solid #ffc1ab;
    padding-bottom: 20px;
    color: #666666;
    font-size: 16px;
    a {
      color: #666;
    }
  }
  .product {
    width: 1200px;
    margin: 0 auto;
    .select {
      height: 44px;
      line-height: 44px;
      overflow: hidden;
      background: #fafafa;
      width: 100%;
      .item {
        display: block;
        float: left;
        cursor: pointer;
        font-size: 14px;
        color: #888;
        margin-left: 70px;
        &.active {
          color: #ff4a0a;
        }
        &.price {
          overflow: hidden;
          span {
            display: block;
            float: left;
          }
          em {
            display: block;
            float: left;
            width: 8px;
            overflow: hidden;
            margin-top: 12px;
            margin-left: 10px;
            i {
              display: block;
              width: 8px;
              height: 6px;
              float: left;
              &.arrow_top {
                background: url("../../assets/imgs/arrow_t.png") no-repeat;
                background-size: 8px auto;
                margin-bottom: 5px;
                &.active {
                  background: url("../../assets/imgs/arrow_t_.png") no-repeat;
                  background-size: 8px auto;
                }
              }
              &.arrow_bottom {
                background: url("../../assets/imgs/arrow_b.png") no-repeat;
                background-size: 8px auto;
                &.active {
                  background: url("../../assets/imgs/arrow_b_.png") no-repeat;
                  background-size: 8px auto;
                }
              }
            }
          }
        }
      }
    }
    .list {
      margin-top: 20px;
      ul {
        overflow: hidden;
        li {
          float: left;
          width: 240px;
          height: 354px;
          a {
            display: block;
            width: 240px;
            padding: 19px;
            box-sizing: border-box;
            border: 1px solid #fff;
            &:hover {
              border: 1px solid #ff4a0a;
              box-shadow: 0px 0px 5px 0px rgba(255, 74, 10, 0.25);
            }
            .photo {
              width: 200px;
              height: 200px;
              img {
                width: 200px;
                height: 200px;
              }
            }
            .name {
              height: 56px;
              font-size: 18px;
              font-weight: 400;
              color: #444444;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              margin: 15px 0;
            }
            .price {
              overflow: hidden;
              span {
                float: left;
                color: #ff4a0a;
                font-size: 18px;
                font-weight: bold;

                &:last-child {
                  float: right;
                  font-size: 14px;
                  color: #999;
                  font-weight: normal;
                }
              }
            }
          }
        }
      }
    }
  }
}
.el-pagination {
  text-align: center;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/pages/product/product_p.vue